import moment from 'moment-timezone';
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../services/session.service';
import { CultureService } from '../services/culture.service';


@Pipe({
    name: 'localDateTime',
    standalone: false
})
export class localDateTimePipe implements PipeTransform {

  constructor(
    private cultureService: CultureService) {}

  transform(value: moment.MomentInput, compensateTimeZone: boolean = true): string {

    if (value === null || value === undefined || value === '') return null;

    var culture = this.cultureService.getCulture();

    const dte = moment.utc(value);

    if (compensateTimeZone) {
      return dte.tz(culture.TimeZone!).format(culture.FormatDateTime);
    }

    return dte.tz('UTC').format(culture.FormatDateTime);
  }
}
